// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gfp2A6SaBKc8g5cqXeSX{white-space:nowrap;gap:4px;width:100%;display:flex;overflow:hidden}.Wv_ro4dwL6chiQmim7t9{visibility:hidden;position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Gfp2A6SaBKc8g5cqXeSX`,
	"hidden": `Wv_ro4dwL6chiQmim7t9`
};
export default ___CSS_LOADER_EXPORT___;
